// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print {\n  /* this is to handle hiding <b-tabs> */\n[data-v-7204cf0a] .non-printable ul,[data-v-7204cf0a] .non-printable ul * {\n    visibility: hidden;\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
